import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import SummaryViewPage from "./SummaryView";

export const SummaryViewModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <SummaryViewPage />
        </ProtectedRoute> 
        {/* <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
          <EditSetBacksPage />
        </ProtectedRoute>  */}
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default SummaryViewModule;
